import React, { useContext, useEffect, useMemo } from "react";
import Notification from "./notificationSubComponents/Notification";
import ProgressBarNotification from "./progressBar/ProgressBarNotification";
import * as genNotifications from "./generateNotificationContent";
import * as shouldNotify from "./shouldDisplayNotification";
import { useHistory } from "react-router-dom";
import { StyledNotificationContainer } from "./notifications.style";
import StateContext from "../../../context/StateContext";
import useSegments from "../../../customHooks/useSegments";

const Notifications = () => {
	const { segMap, hitsMap, plansMap, selectedSegmentCode, dispatch, ACTIONS } = useContext(StateContext);
	const { getSegmentHits } = useSegments();
	const history = useHistory();
	const segData = useMemo(() => (segMap ? segMap[selectedSegmentCode] : {}), [selectedSegmentCode, segMap]);
	const segHits = useMemo(() => (hitsMap ? hitsMap[selectedSegmentCode] : {}), [selectedSegmentCode, hitsMap]);
	const plan = useMemo(() => (plansMap ? plansMap[segData?.plan_id] : {}), [plansMap, segData?.plan_id]);
	useEffect(() => {
		const getLast30Days = async () => {
			// last 30 days data is needed for the progress bar notification
			const { newHitsMap } = await getSegmentHits("LAST_30_DAYS");
			dispatch({ type: ACTIONS.SET_STATE, payload: { hitsMap: newHitsMap, showSpinner: false } });
		};
		if (segData?.state?.toLowerCase() !== "active") {
			getLast30Days();
		}
	}, [segData]);

	return (
		<StyledNotificationContainer>
			<Notification show={shouldNotify.showTrialUnder7Days(plan)} type="info" content={genNotifications.TrialNearEnd(plan?.trial_days_remaining)} CTA={() => history.push("/plans")} />
			<Notification show={shouldNotify.showTrialExpired(plan)} type="warning" content={genNotifications.TrialOver()} CTA={() => history.push("/plans")} />
			<Notification show={shouldNotify.showNoActivePlan(segData, plan)} type="warning" content={genNotifications.NoPlan()} CTA={() => history.push("/plans")} />
			<Notification
				show={shouldNotify.showIntegrationFailure(segData)}
				type="warning"
				content={genNotifications.IntegrationFailure("Facebook")}
				CTA={() => history.push(`/segments/edit/${segData?.code}/facebook`)}
				onDismiss={() => localStorage.setItem(`${segData?.code}_alertedFBIntegrationFailure`, "yes")}
			/>
			<Notification
				show={shouldNotify.showFBIntegrationSuccessful(segData)}
				type="success"
				content={genNotifications.IntegrationSuccess("Facebook")}
				CTA={() => localStorage.setItem(`${segData?.code}_alertedFBIntegrationSuccessful`, "yes")}
				onDismiss={() => localStorage.setItem(`${segData?.code}_alertedFBIntegrationSuccessful`, "yes")}
			/>
			<Notification
				show={shouldNotify.showSegmentActive(segData)}
				type="success"
				content={genNotifications.SegmentActive("Facebook")}
				CTA={() => localStorage.setItem(`${segData?.code}_alertedSegmentActive`, "yes")}
				onDismiss={() => localStorage.setItem(`${segData?.code}_alertedSegmentActive`, "yes")}
			/>
			<ProgressBarNotification
				show={shouldNotify.showAnalyzeProgressBar(segData?.state, segHits?.LAST_30_DAYS?.total)}
				content={genNotifications.noStatsContent(segHits?.LAST_30_DAYS?.total)}
				type="noStats"
			/>
		</StyledNotificationContainer>
	);
};
export default Notifications;
